import { Flag } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getDashboardAssignedTestCaseData } from "../../../modules/project";
import CustomAvatar from "../../elements/CustomAvatar";
import Label from "../../elements/Label";

const AssignedTestCase = ({ projects }) => {
  const [testCaseData, setTestCaseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const fetchTestCaseData = async () => {
    setLoading(true);
    try {
      const response = await getDashboardAssignedTestCaseData(projects);
      setTestCaseData(response?.testcase_data);
    } catch (error) {
      setError(error.message || "Failed to fetch data");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (projects && projects.length > 0) fetchTestCaseData();
  }, [projects]);

  return (
    <Container fluid>
      <Row>
        <Col>
          <h6 className="subheading-text">Assigned in last 24 hours</h6>
        </Col>
      </Row>
      {loading ? (
        <Spinner
          style={{
            display: "block",
            margin: "auto",
            color: "var(--primary-color)",
          }}
        />
      ) : testCaseData && testCaseData.length === 0 ? (
        <Row>
          <Col className="text-center">
            <Card>
              <Card.Body className="card-body-list">
                {error ? (
                  <Typography variant="body2" color="error">
                    {error}
                  </Typography>
                ) : (
                  <Typography variant="body2">
                    No test cases have been assigned to you for execution in the last 24 hours.
                  </Typography>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <>
          {testCaseData &&
            testCaseData.map((testcase) => (
              <Row key={testcase.id} className="mt-2">
                <Col>
                  <Card style={{ padding: "10px !important" }}>
                    <Card.Body className="card-body-list">
                      <Container fluid>
                        <Row className="d-flex justify-content-between align-items-center">
                          <Col md="10">
                            <Box className="d-flex align-items-center">
                              <Box
                                title={testcase.priority}
                                sx={{
                                  bgcolor: testcase.priority_color,
                                  width: "26px",
                                  height: "26px",
                                  borderRadius: "4px",
                                }}
                              >
                                <Flag sx={{ color: "white" }} />
                              </Box>
                              <Box className="ml-2 cursor-pointer" sx={{ marginLeft: "16px" }}>
                                <Typography
                                  variant="subtitle1"
                                  title="Go To Test Case"
                                  onClick={() =>
                                    navigate(
                                      `/project/${testcase?.project?.project_id}/testcases/${testcase.key}`
                                    )
                                  }
                                >
                                  {testcase.summary}
                                </Typography>
                                <Box sx={{ display: "flex" }}>
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted ml-2"
                                  >
                                    {testcase.key} {" - "}
                                    {testcase?.project?.project_name}
                                  </Typography>
                                  <Typography
                                    title="Go To Test Cycle"
                                    variant="subtitle2"
                                    sx={{ ml: 2 }}
                                    className="text-primary ml-2 cursor-pointer"
                                    onClick={() =>
                                        navigate(
                                          `/project/${testcase?.project?.project_id}/testcycles/${testcase.test_cycle_id}?type=testcases`
                                        )
                                      }
                                  >
                                    {testcase.test_cycle_key} {" - "}
                                    {testcase?.test_cycle_name}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Col>
                          <Col>
                            <Box className="d-flex align-items-center justify-content-around">
                              <Label
                                color={testcase?.status_color}
                                name={testcase?.status}
                              />
                              <CustomAvatar
                                firstName={testcase.owner_details?.first_name}
                                lastName={testcase.owner_details?.last_name}
                                size={36}
                              />
                            </Box>
                          </Col>
                        </Row>
                      </Container>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
        </>
      )}
    </Container>
  );
};

export default AssignedTestCase;
